import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "catalogFilter",
})

export class CatalogFilterPipe implements PipeTransform {
  public transform( value: any[], searchString: string ) {
   if (!searchString) {
     return value;
   }

   const searchStringFormatted = searchString.toLowerCase();

   return value.filter( (it) => {
     const name = it.value ? it.value.toLowerCase().includes(searchStringFormatted) : false;
     const key = it.key ? it.key.toLowerCase().includes(searchStringFormatted) : false;
     return name || key;
   });
  }
}
